import { render, staticRenderFns } from "./AgendaIndex.vue?vue&type=template&id=4dac886a&scoped=true"
import script from "./AgendaIndex.vue?vue&type=script&lang=js"
export * from "./AgendaIndex.vue?vue&type=script&lang=js"
import style0 from "./AgendaIndex.vue?vue&type=style&index=0&id=4dac886a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac886a",
  null
  
)

export default component.exports